// Data structures mirroring the C structs (mapgen.h, demon.c).

export interface RoomConnection {
  x: number;
  y: number;
  x2: number;
  y2: number;
  c: number;
  n: RoomConnection | null;
}

export interface Room {
  x: number;
  y: number;
  w: number;
  h: number;
  creator: number;
  visited: number;
  checkpoint: number;
  s_dist: number;
  connections: number;
  room_type: number;
  room_param: number;
  enemies: number;
  con: RoomConnection | null;
}

export function newRoom(): Room {
  return {
    x: 0,
    y: 0,
    w: 0,
    h: 0,
    creator: 0,
    visited: 0,
    checkpoint: 0,
    s_dist: -1,
    connections: 0,
    room_type: 0,
    room_param: 0,
    enemies: 0,
    con: null,
  };
}

export interface Enemy {
  x: number;
  y: number;
  room: number;
  lives: number;
  deaths: number;
  str: number;
  curr_follow: number;
  followdepth: number;
  enemy_type: number;
  image: import('../render/surface').Surface;
  blit_pos: number;
  creationcost: number;
  teleport_v: number;
  speed: number;
  t: number;
  active: number;
  fire_rate: number;
  last_room: number;
  p_last_room: number;
  move_dir: number;
  min_gems: number;
  max_gems: number;
  next: Enemy | null;
  next_active: Enemy | null;
  delete_me: number;
  dying: number;
  m_exit: RoomConnection | null;
}

export interface Bullet {
  x: number;
  y: number;
  firer: Enemy | null;
  parent: Bullet | null;
  room: number;
  speed: number;
  dir: number;
  img: number;
  t: number;
  invuln: number;
  natural_dir: number;
  fire_time: number;
  duration: number;
  turn: number;
  shield_damage: number;
  next: Bullet | null;
  dying: number;
  delete_me: number;
}

export interface Diamond {
  x: number;
  y: number;
  room: number;
  t: number;
  next: Diamond | null;
  next_in_room: Diamond | null;
  prv_in_room: Diamond | null;
  value: number;
  delete_me: number;
}
